import React, { useEffect, useState } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import LinkList from "./LinkList";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllCategoryAttribute } from "./_link_Cat_Att_Action";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const LinkCategoryAtt = () => {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const dispatch = useDispatch();
  let allFetchData =
    useSelector((state) => state.linkCat_Att._allDetails) || [];

  useEffect(() => {
    dispatch(fetchAllCategoryAttribute());
    // eslint-disable-next-line
  }, []);

  let viewComponent;
  viewComponent = <LinkList TableData={allFetchData} filterFn={filterFn} />; //setParentPage={setParentPage} setParentLimit={setParentLimit} setReloadTable={setReloadTable} tableCount={allFetchData.length} />

  return (
    <Page className={classes.root} title="Link">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn} />
        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};

export default LinkCategoryAtt;
